/**
 * The slice of a JSZip instance the report downloads rely on. Typed
 * structurally so `jszip` itself stays a dependency of the host apps.
 */
export type ZipArchive = {
  file(name: string, data: Blob): unknown;
  files: Record<string, unknown>;
  generateAsync(options: { type: "blob" }): Promise<Blob>;
};

export function sanitizeFileName(name: string) {
  return name.replace(/[/\\?%*:|"<>]/g, "-").trim();
}

/** Adds generated PDF blobs into a zip — pass as useDownloadPdfReport(downloader). */
export function createZipCollector(zip: ZipArchive) {
  return async (blob: Blob, fileName?: string) => {
    if (!fileName) {
      throw new Error("Missing file name for zip entry");
    }
    zip.file(fileName, blob);
  };
}
